export default "__VITE_ASSET__CXR6wnxR__"